<template>
  <div class="upload">
    <div class="upload_tip">
      <!--      （支持文件格式：jpg、png，文件大小不超过500kb）-->
    </div>
    <div class="upload_box">
      <Upload
        v-bind="$attrs"
        ref="upload"
        :show-upload-list="true"
        :before-upload="handleBeforeUpload"
        multiple
        action=""
        :format="uploadSetting.format"
        :accept="uploadSetting.accept"
      >
        <div class="btnbox" v-if="!value.url">
          <div class="circle">
            <Icon type="md-add" />
          </div>
          <p>上传头像</p>
        </div>
        <div class="editbox" v-else>
          <img :src="value.url" alt="" />
          <div class="list_item_cover">编辑</div>
        </div>
      </Upload>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadBox',
  props: {
    value: {
      type: Object | File,
      default: () => ({})
    },
    isDel: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value: {
      handler(n) {
      }
    }
  },
  data() {
    return {
      // 后缀名 - 预设
      presetDict: {
        img: ['png', 'jpg', 'jpeg']
      },
      uploadSetting: {
        type: 'photo',
        textTip: '（仅支持jpg、png格式图片）',
        fileSize: 500, //kb
        extPreset: 'img'
      },
      fileList: []
    }
  },
  created() {},
  methods: {
    handleBeforeUpload(file) {
      let { size, name, url } = file
      let { fileSize, extPreset } = this.uploadSetting
      // 文件大小判断
      if (fileSize && size > fileSize * 1024) {
        this.$Message.warning(`文件大小限制：${fileSize}kb`)
        return false
      }

      // 文件类型判断
      if (extPreset) {
        let ext = [...(this.presetDict[extPreset] || [])]
        let fileExt = name.split('.').pop()
        if (!ext.includes(fileExt.toLowerCase())) {
          this.$Message.warning(`请上传以下文件格式：${ext}`)
          return false
        }
      }

      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        file.url = reader.result
        if (this.fileList.length >= 1) {
          this.$Message.warning('图片上传单次不能超过1张!')
        } else {
          this.$emit('input', file)
          this.$emit('beforeUpload', file)
        }
      }
      // 阻止上传
      return false
    },
    handleDelete(file, index) {
      this.fileList.splice(index, 1)
      this.$emit('input', '')
    }
  }
}
</script>

<style lang="less" scoped>
.upload {
  .upload_tip {
  }

  .upload_box {
    display: flex;
    flex-wrap: wrap;

    /deep/ .ivu-upload {
      width: 120px;
      height: 120px;
      margin-left: 2px;
      background: #edeff2;
      border-radius: 50%;
        box-shadow: 0px 1px 4px 0px #cfd1d4;

      .tip {
        // position: absolute;
        // bottom: -50px;
        border-bottom: 1px dashed rgba(236, 238, 240, 1);
        padding-bottom: 5px;
        margin: 0;
        margin-top: 5px;
        font-size: 14px;
        font-weight: 400;
        color: #595b5f;
        line-height: 22px;
      }
    }

    .btnbox {
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .circle {
        width: 32px;
        height: 32px;
        background: #ffffff;
        box-shadow: 0px 1px 4px 0px #cfd1d4;
        border-radius: 50%;
        margin-bottom: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        i {
          font-size: 16px;
          color: #1a45b8;
        }
      }

      p {
        font-size: 14px;
        color: rgba(51, 51, 51, 0.5);
      }
    }

    .editbox {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }

      .close {
        position: absolute;
        top: -10px;
        right: -10px;
        font-size: 20px;
        cursor: pointer;
        color: #9a9cbe;
        z-index: 10;
      }

      .list_item_cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        font-size: 16px;
        color: #fff;
      }

      &:hover {
        .list_item_cover {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}

.tip {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #595b5f;
  line-height: 22px;
  margin: 15px 0;
}
</style>
